<form class="gap-lg grid" [formGroup]="form()">
  <hlm-field class="mt-lg">
    <label hlmLabel for="nom-module" labelRequired>Nom du module</label>
    <input id="nom-module" hlmInput type="text" formControlName="nom" />
  </hlm-field>

  <hlm-field>
    <label hlmLabel for="code-module" labelRequired>Code du module</label>
    <input id="code-module" hlmInput type="text" formControlName="code" />
  </hlm-field>

  <hlm-field>
    <label hlmLabel for="duree-module" labelRequired>Durée</label>
    <input id="duree-module" hlmInput type="number" formControlName="duree" />
    <hlm-field-description>Durée exprimée en heures</hlm-field-description>
  </hlm-field>
</form>
